import './styles.css'

import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ArtifactItem } from '../../../../../types/mentor'
import { iconsList } from './icons'

interface ArtifactsItemsProps {
  artifact: ArtifactItem
  handleChange: (artifact: ArtifactItem) => void
}

export const ArtifactsItem: React.FC<ArtifactsItemsProps> = ({
  artifact,
  handleChange,
}) => {
  const { t } = useTranslation()
  const [showMenu, setShowMenu] = useState(false)
  const [search, setSearch] = useState('')

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChange({
      ...artifact,
      artifactName: event.target.value,
    })
  }

  const handlePromptChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    handleChange({
      ...artifact,
      prompt: event.target.value,
    })
  }

  const handlSetSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value)
  }

  const handleToggleMenu = () => {
    setShowMenu(!showMenu)
  }

  const handleChangeIcon = (icon: string) => {
    handleChange({
      ...artifact,
      iconName: icon,
    })
    handleToggleMenu()
  }

  const filteredIcons = useMemo(
    () =>
      search ? iconsList.filter(icon => icon.includes(search)) : iconsList,
    [search],
  )

  return (
    <div className="mb-4">
      <h3>{t('generation.artifactPrefix')}{artifact.artifactName}</h3>
      <div className="relative  mt-2">
        <button
          onClick={handleToggleMenu}
          className="px-4 tc-mv-question-field  h-10 text-white rounded-full  flex items-center justify-between w-96"
        >
          <span>
            <i className={`fa fa-${artifact.iconName} mr-2`} />
            {artifact.iconName}
          </span>
          <i className="fa-solid fa-chevron-down text-lg" />
        </button>

        {showMenu && (
          <div className="absolute mt-1 left-0 !h-[200px] overflow-auto w-96  shadow-lg z-50 tc-mv-blur rounded-regular p-4">
            <input
              type="text"
              className="px-4 tc-mv-question-field  h-10 text-white rounded-full w-full"
              value={search}
              onChange={handlSetSearch}
              placeholder={t('generation.searchIcon')}
            />
            {filteredIcons.map(icon => (
              <button
                className="hover:bg-black hover:bg-opacity-20 rounded-sm cursor-pointer block w-full text-left"
                key={icon}
                onClick={() => handleChangeIcon(icon)}
              >
                <i className={`fa fa-${icon} mr-4 w-4 p-2`} />
                {icon}
              </button>
            ))}
          </div>
        )}
      </div>

      <input
        type="text"
        className="px-4 tc-mv-question-field  h-10 text-white rounded-full w-full mt-2"
        value={artifact.artifactName}
        onChange={handleNameChange}
        placeholder={t('generation.enterArtifactName')}
      />
      <textarea
        className="px-4 tc-mv-question-field  h-10 text-white rounded-full w-full mt-2"
        value={artifact.prompt}
        onChange={handlePromptChange}
        placeholder={t('generation.enterArtifactPrompt')}
      />
    </div>
  )
}
